// extracted by mini-css-extract-plugin
module.exports = {"container":"spinner_container__bU_kg","spinner":"spinner_spinner__xAnlp","spin":"spinner_spin__u_7ep"};